var _defs, _image, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path15, _path16, _line8, _line9, _line10, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _path17, _path18, _line11, _line12, _line13, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3Str1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 480,
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #39a935;\n        stroke-width: 5px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #39a935;\n        stroke: #1d1d1b;\n        stroke-width: 0.5px;\n      }\n    "))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 640,
    height: 480,
    xlinkHref: "../floor/2.png"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M503.06,170.68c0,27.18,0,67.53,0,108.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224,330c55.51,0,137.92,0,221.62,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.92,346.14c25.44-4,63.16-10.21,101.53-16.16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.18,346c10.8-.07,26.84.14,43.12,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.22,410.08c15.37-.09,38.2.18,61.38,0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.11,410c15.37-.09,38.2.18,61.37,0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M359.29,330c.1,23.79-.21,59.11,0,95"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.4,330c.15,23.79-.29,59.11,0,95"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.6,330v80.51"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.41,253.72c15.37-.09,38.19.18,61.37,0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.05,279.18c14.06-.08,34.93.14,56.13,0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.93,276.94c.07,17.26-.13,42.89,0,68.92"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.8,389.9c-.06-11.62.11-28.87,0-46.39"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.22,375.64c.11,3.43-.22,8.52,0,13.69"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 503.06,
    y1: 279.19,
    x2: 503.07,
    y2: 306.74
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 505.57,
    y1: 306.84,
    x2: 445.95,
    y2: 306.84
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 446.16,
    y1: 304.34,
    x2: 446.16,
    y2: 351.18
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 446.18,
    y1: 352.61,
    x2: 446.18,
    y2: 407.15
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 443.66,
    y1: 350.94,
    x2: 478.38,
    y2: 350.94
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 478.55,
    y1: 348.43,
    x2: 478.55,
    y2: 395.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 507.68,
    y1: 395.28,
    x2: 507.68,
    y2: 367.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478.55,395.42c0,6.95,5.2,10.83,14.55,10.83"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.68,395.28c0,7-5.22,11-14.58,11"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 503.06,
    y1: 248.1,
    x2: 450.03,
    y2: 248.1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 542.26,
    y1: 248.1,
    x2: 542.26,
    y2: 279.19
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 503.54,
    y1: 279.2,
    x2: 544.77,
    y2: 279.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "503.07 187.32 508.44 177.92 497.69 177.92 503.07 187.32"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "503.07 215.67 508.44 206.27 497.69 206.27 503.07 215.67"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "464.53 248.1 455.13 242.73 455.13 253.48 464.53 248.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "502.68 254.37 508.05 244.97 497.31 244.97 502.68 254.37"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "542.26 262.4 547.63 253 536.88 253 542.26 262.4"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "502.68 297.67 508.05 288.27 497.31 288.27 502.68 297.67"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.16 326.12 451.54 316.72 440.79 316.72 446.16 326.12"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.16 347.6 451.54 338.2 440.79 338.2 446.16 347.6"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.18 366.55 440.81 375.94 451.56 375.94 446.18 366.55"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "446.18 390.35 440.81 399.75 451.56 399.75 446.18 390.35"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "420.3 395.05 414.93 404.45 425.68 404.45 420.3 395.05"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "359.31 393.49 353.94 402.88 364.68 402.88 359.31 393.49"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.9 410.02 325.3 415.4 325.3 404.65 315.9 410.02"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "280.48 410.02 289.88 415.4 289.88 404.65 280.48 410.02"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "199.38 410.49 208.78 415.86 208.78 405.11 199.38 410.49"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "167.42 410.1 176.82 415.47 176.82 404.72 167.42 410.1"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "269.6 384.09 264.22 393.49 274.97 393.49 269.6 384.09"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "268.82 346.48 263.45 355.88 274.2 355.88 268.82 346.48"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "255.07 330.03 264.47 335.41 264.47 324.66 255.07 330.03"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.1 345.86 95.5 351.24 95.5 340.49 86.1 345.86"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "198.7 253.71 189.3 248.33 189.3 259.08 198.7 253.71"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.6 279.16 72.2 273.79 72.2 284.54 81.6 279.16"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "113.81 279.23 104.42 273.85 104.42 284.6 113.81 279.23"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "233.37 253.71 223.97 248.33 223.97 259.08 233.37 253.71"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "337.88 330.03 328.49 324.66 328.49 335.41 337.88 330.03"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "399.24 329.98 389.84 324.61 389.84 335.36 399.24 329.98"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "436.01 330.03 426.61 324.66 426.61 335.41 436.01 330.03"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "359.22 346.48 353.84 355.88 364.59 355.88 359.22 346.48"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "420.3 346.24 414.93 355.63 425.68 355.63 420.3 346.24"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "517.89 279.19 527.29 284.57 527.29 273.82 517.89 279.19"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "479.86 306.84 489.26 312.21 489.26 301.46 479.86 306.84"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "478.55 381.24 483.92 371.84 473.17 371.84 478.55 381.24"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "507.64 371.84 502.27 381.24 513.02 381.24 507.64 371.84"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "452.67 306.84 462.06 312.21 462.06 301.46 452.67 306.84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.79,388.55c0,4.64-4.5,8.39-10.06,8.39"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.16,387.85a9.34,9.34,0,0,0,9.59,9.08"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.55,
    y1: 346.03,
    x2: 107.55,
    y2: 410.1
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156.73,
    y1: 340.7,
    x2: 156.73,
    y2: 410.49
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 241.48,
    y1: 330.03,
    x2: 241.29,
    y2: 253.77
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.73 383.07 151.36 392.47 162.11 392.47 156.73 383.07"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.55 388.04 102.17 397.44 112.92 397.44 107.55 388.04"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107.55 359.01 102.17 368.41 112.92 368.41 107.55 359.01"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.14 383.89 53.77 393.29 64.52 393.29 59.14 383.89"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "156.73 349.61 151.36 359.01 162.11 359.01 156.73 349.61"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "206.36 333.97 216.72 337.14 214.34 326.65 206.36 333.97"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "169.56 339.45 179.91 342.62 177.54 332.13 169.56 339.45"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.84 345.58 145.19 348.75 142.82 338.27 134.84 345.58"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "241.39 279.64 246.76 270.25 236.01 270.25 241.39 279.64"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.89 298.17 128.26 288.77 117.51 288.77 122.89 298.17"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.89 329.14 128.26 319.74 117.51 319.74 122.89 329.14"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "241.39 314.68 246.76 305.28 236.01 305.28 241.39 314.68"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.49 393.93 83.86 384.53 73.11 384.53 78.49 393.93"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.49 366.71 83.86 357.31 73.11 357.31 78.49 366.71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Str1);
export default __webpack_public_path__ + "static/media/3 str_Монтажная область 1.97c93cf9dab6f7057211346aafe70e9c.svg";
export { ForwardRef as ReactComponent };